module.exports = __webpack_public_path__ + "img/oops-pc.7655c6fd.png";